import { Injectable, NgZone } from '@angular/core';

import { UserService } from './user.service';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private userService: UserService) {
  }

  translate() {
    const elements = document.querySelectorAll('[data-lng]');
    if (elements !== null && elements !== undefined) {
      for (const htmlElement of <any>elements) {
        const theTag = htmlElement.getAttribute('data-lng');
        if (theTag !== undefined && theTag !== null) {
          htmlElement.setAttribute('data-lng', "");
          let theText = this.LNG(theTag.toLowerCase());
          htmlElement.removeAttribute('data-lng');

          const uc = htmlElement.getAttribute('data-uc');
          if (uc !== undefined && uc !== null && uc)
            theText = theText.toUpperCase();

          if (htmlElement.nodeName === 'optgroup')
            htmlElement.setAttribute('label', theText);
          //else if (false)
          //  htmlElement.xxxxx('yyyyyy', theText);
          else
            htmlElement.innerHTML = theText;
        }
      }
    }
  }

  /* Returns the tag itself if not found  */
  LNG(tag) {
    const _tag = (typeof (tag) !== "undefined" && tag !== null ? ("" + tag) : "");
    const ltt = (typeof (this.userService.languageTagTexts) !== "undefined");
    const text = (ltt && this.userService.languageTagTexts !== null) ? this.userService.languageTagTexts[_tag.toLowerCase()] : "";
    /* LanguageTag hashtable NOTE! : All keys must be lower case!  */
    if (ltt && typeof (text) !== "undefined") {
      return text;
    }
    else {
      return _tag;
    }
  }
}
